import styled from 'styled-components';

import { LoadMore, Text } from '../../components';
import { ANIM, COLORS, PRODUCT } from '../../theme/tokens';

/** Groups a section title with its card list so the PageShell gap separates sections, not rows. */
export const Section = styled.section``;

// --- New-website calibration note -------------------------------------------
// A quiet caption under the insights panel, shown only while the launch
// calibration is still lifting the score (website younger than the calibration
// window). An info glyph anchors it; the copy stays muted so it reads as a
// footnote, mirroring the acquisition channels' disclaimer note. It clears on
// its own once the score settles to its real value.
export const CalibrationNote = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: -4px;
`;

export const CalibrationNoteIcon = styled.span`
  display: flex;
  flex-shrink: 0;
  color: ${COLORS.textMuted};
`;

export const CalibrationNoteText = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.01em;
  text-align: center;
  color: ${COLORS.textMuted};
`;

// The outer list panel that holds the feature cards — the same nested surface the
// other roots use (Players' Container, Acquisition Campaigns / Operations Promotions'
// Panel): a darker #101012 well with the lighter cards sitting on it, so every root
// reads as one consistent "titled section over a card container".
export const Container = styled.div`
  background: ${PRODUCT.containerBg};
  border-radius: 18px;
  padding: 8px;
`;

export const FeatureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

/** Animated reveal for the features beyond the first three (0fr → 1fr row trick). */
export const Drawer = styled.div<{ $open: boolean }>`
  display: grid;
  grid-template-rows: ${(p) => (p.$open ? '1fr' : '0fr')};
  transition: grid-template-rows ${ANIM.DRAWER_MS}ms cubic-bezier(0.22, 1, 0.36, 1);
`;

export const DrawerInner = styled.div`
  min-height: 0;
  overflow: hidden;
`;

/** Keeps the list gap between the always-visible cards and the drawer content. */
export const DrawerList = styled(FeatureList)`
  padding-top: 10px;
`;

/** Ghost see-more/see-less toggle — the design draws it without a border. */
export const SeeMoreToggle = styled(LoadMore)`
  button {
    border: none;
  }
`;